import { createContext, useContext, useEffect, useState } from 'react';
import useApi from './api/useApi';

const FEATURES_ENDPOINT =
  '/api/app/feature/00000000-0000-0000-0000-000000000000';

const FeaturesContext = createContext(null);

export const FeaturesProvider = ({ children }) => {
  const api = useApi();
  const [features, setFeatures] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    api
      .get(FEATURES_ENDPOINT)
      .then((res) => {
        setFeatures(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [api]);

  return (
    <FeaturesContext.Provider value={{ features, isLoading }}>
      {children}
    </FeaturesContext.Provider>
  );
};

const useFeatures = () => {
  const context = useContext(FeaturesContext);
  if (context === null) {
    throw new Error('useFeatures must be used within a FeaturesProvider');
  }
  return context;
};

export default useFeatures;
